// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter

import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";
import { CheckoutPage } from "@/app/billing/upgrade/checkout/checkout";

const searchParamsSchema = z.object({
  error: z.string().optional(),
  originalPlanId: z.string().optional(),
});

const defaultValues = {
  error: "",
};

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId"
)({
  component: CheckoutPage,
  validateSearch: searchParamsSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  loader: ({ params }) => ({
    crumb: "Checkout",
    planId: params.planId,
  }),
});
